import React, { useContext } from 'react'
import { ELanguage, JobCardMini, Utils } from '@microfrontends/react-components'
import { useInitialData } from '@microfrontends/app-shell-v2'
import { withTranslation } from './../i18n'
import AppContext from '../context/AppContext'

const isMobile = function () {
	return typeof window !== 'undefined' ? window.innerWidth < 768 : false
}

const JobBlockComponent = (props) => {
	const { languageCode: langCode, user } = useContext(AppContext)
	const address = props.address || ''
	const title = props.title
	const company = props.company
	const logoUrl = props.logo
	const locations = (props.workingLocations || []).map((location) =>
		langCode === ELanguage.EN ? location.cityName : location.cityNameVI
	)
	const locationText =
		locations.length > 0
			? locations.join(', ')
			: langCode === ELanguage.EN
			? props.cityNamesEN
			: props.cityNames

	const jobDescription = props.jobDescription || ''
	const jobRequirement = props.jobRequirement || ''
	const jobId = props.jobId || -1
	let salary = props.salary
	if (salary === 'Thương lượng' || salary === 'Negotiable') {
		salary = langCode === ELanguage.EN ? 'Negotiable' : 'Thương lượng'
	}
	const jobLevel = props.jobLevel
	const isSaved = !!props?.isSaved
	const isApplied = !!props?.isApplied
	const isBlackList = !!props?.isBlackList
	const redirectTo = props?.redirectTo || ''
	const isAnonymous = !!props.isAnonymous

	const jobDetailUrl = `/${props?.alias}-${props?.jobId}-${
		langCode === ELanguage.EN ? 'jd' : 'jv'
	}`
	const jobLevelId= props.jobLevelId ?? 0
	const companyAlias = Utils.slugify(props?.company || '')
	let companyUrl = `/${
		langCode === ELanguage.EN ? 'companies' : 'nha-tuyen-dung'
	}/${companyAlias}-c${props?.companyId}`

	if (props?.isAnonymous) {
		companyUrl = ''
	}
	 const userInfo ={...user, jobLevelId:user?.jobLevelId[0] ??0}
	const initData = useInitialData(props.langCode)

	return (
		<JobCardMini
			isMobile={isMobile()}
			item={{
				jobTitle: title,
				jobId: jobId,
				jobUrl: jobDetailUrl,
				companyLogo: logoUrl,
				company,
				companyUrl: companyUrl,
				address: address,
				jobDescription: jobDescription,
				jobRequirement: jobRequirement,
				isSaved: isSaved,
				jobLevelId:jobLevelId,
				isApplied: isApplied,
				isBlackList: isBlackList,
				redirectTo: redirectTo,
				isAnonymous,
				locationText,
				jobLevelText: jobLevel,
				prettySalary: salary,
				jobInvitation: props.jobInvitation ?? { jobInvitationId: 0, status: 0 }
			}}
			displayOptions={{
				isHot: props.isHotJob
			}}
			langCode={langCode}
			api={{
				baseUrl: process.env.API_DOMAIN,
				accessToken: props?.accessToken,
				appId: process.env.VNW_APP_ID,
				source: 'Find Jobs'
			}}
			previewJob={{
				enable: !isMobile(),
				appMode: 'production',
				baseUrl: process.env.VNW_BASE_URL
			}}
			settingJob={{
				showType: !!props.isFinalIndex
			}}
			classSelector={props.classSelector}
			userInfo={userInfo}
			initData={initData}
		/>
	)
}

const JobBlock = withTranslation('home')(JobBlockComponent)
export default JobBlock
